import React from 'react'

import { Field } from 'formik'

import { Table, Form } from '_zari/core'

const FlagOrdenCompraCell = ({ row, dispatch, iValue, handleChange, setFieldValue }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      setFieldValue('_idSocio', '')
      setFieldValue('precio', '')

      dispatch({
        type: 'actualizar',
        payload: {
          ...row,
          flagOrdenCompra: e.target.checked,
          _idSocio: '',
          precio: ''
        }
      })
    },
    [handleChange, dispatch, row, setFieldValue]
  )

  return (
    <Table.Cell>
      <Field name='flagOrdenCompra'>
        {({ field }) => (
          <Form.Checkbox
            {...field}
            checked={iValue}
            onChange={onChange}
            id={`${row._idFila}-ordenCompra`}
            label='Orden Compra'
          />
        )}
      </Field>
    </Table.Cell>
  )
}

export default React.memo(FlagOrdenCompraCell)
